import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import D3ErrorBoundary from "../../components/D3ErrorComponent.js";
import d3SankeyChartBuilder from "./SankeyChartBuilder.js";
import { sankeyDataTransformer } from "./utils.js";
import { store } from "../../util/store.js";
import ExportPPtx from "../../components/ExportPPT.js";

const D3SankeyContainer = (props) => {
  const chartRef = useRef(null);

  const Symbol = store.getState();
  const Currency_Symbol = Symbol.app.user.Currency;

  console.log(props, "titleMap");
  const elementId = `svgContainer${props.id}`;
  const [isChartDrawn, setIsChartDrawn] = useState(false);
  useEffect(() => {
    const svgContainer = document.getElementById(elementId);
    let data = sankeyDataTransformer(
      props.tableData.data.filter((it) => it.Opp_Count > 0),
      props.tableData[props.fqType],
      props.tableData.allStagesSet,
      {
        source: `${props.titleLabel} initially`,
        quarterRefernce: props.tableData.fqType,
        countReference: "Opp_Count",
        acvReference: "ACV",
        toogleValue: props.toggleValue,
      }
    );
    console.log(data, "sankey_pipeline_progression");
    // data = data.map((it) => ({
    //   ...it,
    //   value: it[props.toggleValue === "count" ? "value" : "acv"],
    // }));
    const options = {
      label:
        props.toggleValue === "count" ? "# of Opps" : `${props.Value_Label}`,
      isAcv: props.toggleValue === "count" ? "" : `${Currency_Symbol}`,
      stageToColorMap: props.tableData.stageToColorMap,
      tilteLabel: props.label,
    };
    // // console.log(data,'data')
    // // console.log(data.map(it=>({...it,value:it.acv})))
    const result = d3SankeyChartBuilder.create(data, svgContainer, options);
    // setIsChartDrawn(result);
    return () => {
      const el = document.getElementById(elementId);
      d3SankeyChartBuilder.remove(el);
    };
  }, [props.tableData, props.toggleValue, isChartDrawn]);
  console.log(props.tableData, "sankey_pipeline_progression");
  return (
    <>
      {isChartDrawn && (
        <D3ErrorBoundary>
          <Grid style={{ display: "flex", justifyContent: "center" }}>
            {!isChartDrawn && (
              <Typography align="center" variant="h2">
                Chart Not Loaded
              </Typography>
            )}
            <div
              style={{ display: "flex", justifyContent: "center" }}
              id={elementId}
            ></div>
          </Grid>
        </D3ErrorBoundary>
      )}
      {!isChartDrawn && (
        <D3ErrorBoundary>
          <Grid container item style={{ padding: "1rem" }}>
            <Grid container item xs={12}>
              <Grid item xs={1}></Grid>
              <Grid item xs={10}></Grid>
              <Grid
                item
                xs={1}
                style={{
                  padding: "0.5rem",
                  height: "2rem",
                  display: "flex",
                  justifyContent: "flex-end", // aligns children to the right
                  alignItems: "center",
                  gap: "0.5rem", // adds space between toggle and button
                }}
              >
                <ToggleButtonGroup
                  color="primary"
                  indicatorColor="primary"
                  value={props.toggleValue}
                  exclusive
                  size="small"
                  onChange={props.handleChangeToggle}
                >
                  <ToggleButton
                    style={{
                      background:
                        props.toggleValue === "count" ? "#4472C4" : "",
                      color: props.toggleValue === "count" ? "white" : "",
                      fontSize: "1rem",
                      fontWeight: 600,
                      width: "3rem",
                      height: "2rem",
                    }}
                    value="count"
                  >
                    #
                  </ToggleButton>
                  <ToggleButton
                    style={{
                      background: props.toggleValue === "acv" ? "#4472C4" : "",
                      color: props.toggleValue === "acv" ? "white" : "",
                      fontSize: "1rem",
                      fontWeight: 600,
                      width: "3rem",
                      height: "2rem",
                    }}
                    value="acv"
                  >
                    {/* $ */}
                    {Currency_Symbol}
                  </ToggleButton>
                </ToggleButtonGroup>

                <ExportPPtx
                  chartRef={chartRef}
                  title={props.titelforpptx}
                  fileName={props.fileNameForPPTX}
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent="center"
              style={{ padding: "2rem" }}
              ref={chartRef}
            >
              <div
                style={{ display: "flex", justifyContent: "center" }}
                id={elementId}
              ></div>
            </Grid>
          </Grid>
        </D3ErrorBoundary>
      )}
    </>
  );
};

export default D3SankeyContainer;
